import { useState } from 'react';
import { faqs } from '@/mocks/russianMom';

export default function FaqSection() {
  const [open, setOpen] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1000px] px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-question-line" aria-hidden="true"></i>
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于观看与资源，你可能想知道
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-7 text-foreground-600">
            汇总了浏览本站时最常被问到的几个问题，点击即可展开查看解答。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f) => {
            const isOpen = open === f.id;
            return (
              <div
                key={f.id}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? 'border-primary-200 bg-background-100' : 'border-background-200 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : f.id)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center gap-3 px-4 py-4 text-left md:px-5"
                >
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                  </span>
                  <span className="flex-1 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                    {f.q}
                  </span>
                </button>
                {isOpen && (
                  <div className="animate-fade-up px-4 pb-4 pl-14 pr-5 md:px-5 md:pl-16">
                    <p className="text-sm leading-7 text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}